import { Component, Input, OnInit, inject } from '@angular/core';
import { ButtonSize, ButtonState, ButtonType } from '../../../../../../assets/types/dtoTypes';
import { ForgotPasswordService } from '../../forget-password-page.service';
import { BreakpointsService, BIPPERZ_BREAKPOINTS } from '../../../../../shared/services/breakpoint.service';
import {ButtonComponent} from "../../../../../shared/button/button.component";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'app-check-email-form',
  templateUrl: './check-email-form.component.html',
  styleUrls: ['./check-email-form.component.scss'],
  imports: [
    ButtonComponent,
    TranslateModule
  ],
  standalone: true
})
export class CheckEmailFormComponent implements OnInit {
  private forgotPasswordService = inject(ForgotPasswordService);
  private breakpointsService = inject(BreakpointsService);

  @Input() userEmail: string;

  isLoading: boolean = false;

  backendError!: string;

  isButtonDisabled: boolean = false;


  protected readonly ButtonSize = ButtonSize;

  protected readonly ButtonState = ButtonState;

  protected readonly ButtonType = ButtonType;

  protected isMobile: boolean;

  constructor() {
  }

  ngOnInit(): void {
    this.breakpointsService.observe( [ BIPPERZ_BREAKPOINTS.s, BIPPERZ_BREAKPOINTS.m_down ] ).subscribe( (result ) => {
      this.isMobile = result.s || result.m_down;
    } );
  }

  resend() {
    this.isLoading = true;
    this.isButtonDisabled = true;

    this.forgotPasswordService.resendEmail().subscribe( {
      next: () => {
        this.isLoading = false;
        this.resetButtonState();

      },
      error: ( error ) => {
        this.isLoading = false;
        this.backendError = error.error.message;
        this.resetButtonState();

        console.error( 'Error resending email link:', error );
      },
    } );
  }

  resetButtonState() {
    setTimeout( () => {
      this.isButtonDisabled = false;
    }, 30000 );
  }
}

